import React from "react";
import parseChildren from "../../utils/parseChildren";
import { AssistantPanel, DetailPageContent, } from "../../layouts/DetailPage/DetailPageContent";
import { LoadingScreen } from "../../LoadingScreen";
import { OpacityOverlay } from "../../OpacityOverlay";
import { DetailPageOverview } from "../../layouts/DetailPage/DetailPageOverview";
import { DetailContext } from "../../hooks/useDetailContext";
import { classNames } from "../../utils/classNames";
import { CentreCol, LayoutContainer, LeftCol, Page, RightCol } from "../Layout";
import { Header } from "../..";
export const FutureDetailPage = ({ children, title, detailType, legacyId, form, loading, back, header, layout = "stacked", navigation, page, }) => {
    const detailChildren = parseChildren(children);
    const content = detailChildren.findByType(DetailPageContent);
    const overview = detailChildren.findByType(DetailPageOverview);
    const assistant = detailChildren.findByType(AssistantPanel);
    if (loading && !legacyId) {
        return React.createElement(LoadingScreen, null);
    }
    return (React.createElement(Page, { className: classNames("detail-page", `detail-${layout}`) },
        React.createElement(DetailContext.Provider, { value: {
                title,
                legacyId,
                detailType,
                form,
                loading,
                layout,
                page,
            } },
            React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
                React.createElement(Header, { title: title, extra: header?.extra, reference: header?.reference, back: back, navigation: navigation, usage: "portal" }, header?.children)),
            React.createElement(LayoutContainer, null,
                overview && React.createElement(LeftCol, null, overview),
                React.createElement(CentreCol, null,
                    React.createElement(OpacityOverlay, { on: form.saveState === "saving" }, content)),
                assistant && React.createElement(RightCol, null, assistant)))));
};
